export default __webpack_public_path__ + "ade04eb65baea27d2dc08e959aa26619.png";